import React from "react";
import { ReactComponent as CecoLogo } from "../../assets/svg/ic_cecotec.svg";
import "./Header.scss";
import CecoCareBanner from "../CecoCareBanner/CecoCareBanner";

export default function Header() {
  return (
    <div className="header">
      <CecoLogo />
      <CecoCareBanner />
    </div>
  );
}
